"use client"

import React, { useState } from "react"

type Props = React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement>

const Figcaption = (props: Props) => {
	const [copied, setCopied] = useState(false)

	const handleCopy = (e: React.MouseEvent<HTMLButtonElement>) => {
		const fig = (e.currentTarget as HTMLElement).closest("figure")
		const code = fig?.querySelector("pre code")

		if (code) {
			const text = code.textContent || ""
			navigator.clipboard
				.writeText(text)
				.then(() => {
					setCopied(true)
					setTimeout(() => setCopied(false), 3000)
				})
				.catch((err) => {
					console.error("Nie udało się skopiować:", err)
				})
		}
	}

	return (
		<figcaption className="figcaption w-full min-w-0 max-w-full" {...props}>
			<span className="min-w-0 flex-1 overflow-x-auto whitespace-nowrap [-webkit-overflow-scrolling:touch]">
				{props.children}
			</span>

			<button
				onClick={handleCopy}
				className="btn btn-linear hover-up hover-shadow inline-block min-w-[4.5rem] shrink-0 text-center transition-all duration-300 sm:min-w-[5.625rem]"
				type="button"
			>
				{copied ? "Copied!" : "Copy"}
			</button>
		</figcaption>
	)
}

export default Figcaption
